export const TECHNOLOGY_FIELD = 'technology';
export const BAND_FIELD = 'band';
export const RADIUS_FIELD = 'radius';
export const BEAMWIDTH_FIELD = 'beamwidth';

export const deleteCellSettingsTooltip = 'Delete sectors settings';

export const editCellSettingsTooltip = 'Edit sectors settings';
